const prod = {
  baseURL: `https://api.growthsphereinvestment.com/api/v1`,
  apiURL: `https://api.growthsphereinvestment.com`,
};

const dev = {
  baseURL: `http://localhost:4002/api/v1`,
  apiURL: `http://localhost:4002`,
  // baseURL: `https://api.growthsphereinvestment.com/api/v1`,
  // apiURL: `https://api.growthsphereinvestment.com`,
};

export const config = process.env.NODE_ENV === `development` ? dev : prod;
